<div class="form-panel-container">
    <div class="form-container" [ngClass]="{ readonly: _context?.formMode === FormMode.Reading }">
        @for (paramsValue of dataInput.paramsSetsParams; track paramsValue) {
            <div>
                @if (paramsValue.paramType === 'Boolean') {
                    <app-parameters-value-form
                        #pvfc
                        [paramsValue]="paramsValue"
                        [parentValue]="parentValue(paramsValue.paramName)"
                        [disabled]="disabled"
                        (paramsValueUpdated)="paramsValueUpdated($event)"></app-parameters-value-form>
                }
            </div>
        }
        @for (paramsValue of dataInput.paramsSetsParams; track paramsValue) {
            <div>
                @if (paramsValue.paramType !== 'Boolean') {
                    <app-parameters-value-form
                        #pvfc
                        [paramsValue]="paramsValue"
                        [parentValue]="parentValue(paramsValue.paramName)"
                        [disabled]="disabled"
                        (paramsValueUpdated)="paramsValueUpdated($event)"></app-parameters-value-form>
                }
            </div>
        }
    </div>
    <div class="buttons-container">
        <button mat-stroked-button class="accent-button" [disabled]="!formIsValid" [ngClass]="{ disabled: !formIsValid }" (click)="cancel()">Annuler</button>
        <button mat-raised-button class="accent-button" [disabled]="!formIsValid" [ngClass]="{ disabled: !formIsValid }" (click)="manualSave()">Enregistrer</button>
    </div>
</div>
